import React from 'react';
import PropTypes from 'prop-types';

import { Container, SectionHeader } from './styles';

export default function PageTitle({ title, subtitle, onBack, children, size, tags, extra }) {

  return size === 2 ? (
    <SectionHeader>
      <span>{title}</span>
      {children}
    </SectionHeader>
  ) : (
    <Container onBack={onBack} title={title} subTitle={subtitle} tags={tags} extra={extra}>
      {children}
    </Container>
  );
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  onBack: PropTypes.func,
  tags: PropTypes.node,
  extra: PropTypes.node,
};

PageTitle.defaultProps = {
  children: <></>,
  subtitle: null,
  onBack: null,
  size: 1,
  tags: null,
  extra: null,
};
